/**
 * Created by Rene Lopez on 11/02/16.
 */

// ListDetailsView.js

import $ from 'jquery';
import _ from 'lodash';

import { View,Model } from 'backbone';
import NotificationService from 'NotificationService';
import RestService from 'RestService';
import util from 'util/Util';

import eventBus  from 'EventBus';
import constants        from 'Constants';
import contentTemplate  from 'dashboard/settings/list-details-view.ejs';
import SettingsHelpView from 'dashboard/settings/SettingsHelpView';
import SimpleConfirmModal from 'common-views/SimpleConfirmModalView';
import QuickPasteModal from 'common-views/QuickPasteModalView';
import CommonImportModal from 'common-views/CommonImportModalView';
import undoService from 'UndoService'
import textConstants from 'TextConstants';
import dashboardService from 'DashboardService';
import listService from 'ListService.js';

class ListDetailsView extends View {

    initialize( opts ) {

        this.options = opts || {};
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.template = contentTemplate;

        this.events = {
            "click .itemNew"              : "itemNew",
            "click .itemRemove"           : "itemRemove",
            "click .itemUp"               : "itemUp",
            "click .itemDown"             : "itemDown",
            "keyup input[name=Name]"     : "changeListName",
            "click button[name=quickPaste]": "quickPaste",
            "click input[name=cancelChanges]": "cancelChanges",
            "click input[name=applyChanges]": "applyChanges",
            "click input[name=delete]": "deleteList",
            "click input[name=import]": "importList",
            "click #goToSettings": "goToSettings",
            "click #goToAccountSettings": "goToAccountSettings"
        };
        this.model.set({
            colModel: [
                {
                    name: 'caption',
                    index: 'caption',
                    editable:true
                },
                {
                    name: 'value',
                    index: 'value',
                    editable:true
                }
            ],
            colNames: ['Caption', 'Value']
        }, {silent: true});
        this.onResize();
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).bind('resize',() => {this.resizeGrid();})
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }
    changeNameLeftPanel(id, value){
        try {
            $("#wellListsGroup a[data-itemid='"+id+"']").html(value);
        }catch(error){
        }
    }

    changeListName(ev){
        let currentModel = this.model.get('currentListDetails');

        // PF-5944 Validate if value actually change (for keyup event)
        if (currentModel[ev.target.name] !== ev.target.value) {
            currentModel[ev.target.name]=ev.target.value;
            this.model.set("currentListDetails",currentModel,{silent:true});
            this.model.set("hasChanges",true,{silent:true});
    
            this.changeNameLeftPanel(this.model.get('listId'), ev.target.value);
            const listId = this.model.get('listId');
            // this.render();
            // Show apply changes
            $("#actionsSection").addClass('hide');
            $('#changesSection').removeClass('hide');

        }
       
    }

    formatListForResponse(model) {
       let  currentModelItems=model.CustomListXML.CustomList ? model.CustomListXML.CustomList.Item:[],
            listXML;
        let listOpeningTag = '<CustomList>';
        let listClosingTag = '</CustomList>';
        let listBody = currentModelItems.reduce((accum, elem)=> {
            elem['@caption'] = util.escapeXMLChars(elem['@caption'])
            elem['@value'] = util.escapeXMLChars(elem['@value'])
            return accum + `<Item caption="${elem['@caption']}" value="${elem['@value']}"/>`
        }, '');
        listXML = listOpeningTag + listBody + listClosingTag;
        console.log('CurrentListBeforeReplacing', listXML);
        listXML = listXML.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        console.log('CurrentListToSend', listXML);
        return listXML;
    }

    applyChanges() {
        let currentModel = this.model.get('currentListDetails');
        const listId = this.model.get('listId');

        console.log("Applying Changes", currentModel);
        let updateData = {
            customListId: listId,
            name:currentModel.Name,
            customListXML:this.formatListForResponse(currentModel)
        };
        console.log("Parameters to Send",updateData);

        const originalModel = this.model.get('listDetails')

        const originalData = {
            customListId: listId,
            name: originalModel.Name,
            customListXML: this.formatListForResponse(originalModel)
        };

        undoService.add({
            undo: () => {
                this.persistData(originalData);
            },
            redo: () => {
                this.persistData(updateData);
            }
        }, textConstants.UNDO_UPDATE_LIST)

        this.persistData(updateData);
        util.setUndoRedoAccess();
    }

    persistData(data){
        RestService.updateCustomList(data).then((updateResponse)=> {
            console.log('Updated Custom List Response', updateResponse);
            if (listService.activeDashboardTab === 'settings'){
              eventBus.trigger(constants.EV_UPDATE_EXPAND_CUSTOM_LIST_DETAILS, this.model.get('listId'));
            }
        }).catch((err=> {
            console.log('Error Applying changes on Custom List Details', err);
            NotificationService.error('Error Applying changes on Custom List Details' + err.MESSAGE);
        }));
    }

    deleteList(ev) {
        dashboardService.deleteUserList();
    }

    cancelChanges() {

        this.model.set('currentListDetails',$.extend(true, {}, this.model.get('listDetails')),{silent:true});
        this.model.set('hasChanges',false,{silent:true});

        let listDetails = this.model.get('listDetails');
        this.changeNameLeftPanel(this.model.get('listId'),listDetails.Name);
        this.render();
    }
 
    renderGrid(){
        let self = this;
        let itemsToRender=this.model.get('currentListDetails').CustomListXML.CustomList.Item;
        let gridObject = util.getGridObject(this,{autowidth:true,height:400,scrollOffset:0});
        $(this.gridEl).jqGrid(gridObject);
        _.forEach(itemsToRender, (field, index) => {
            self.fillNewRow(index, field['@caption'], field['@value'])
        });
    }

    itemUp(){
        let myGrid = $(this.gridEl),
            selRowId = parseInt(myGrid.jqGrid ('getGridParam', 'selrow')),
            currentModel=this.model.get('currentListDetails'),
            currentModelItems=currentModel.CustomListXML.CustomList.Item;

        if ( selRowId > 0 ){
            currentModelItems[selRowId] = currentModelItems.splice((selRowId-1), 1, currentModelItems[selRowId])[0];
            currentModel.CustomListXML.CustomList.Item=currentModelItems;
            this.model.set('currentListDetails', currentModel,{silent:true});
            this.model.set('hasChanges',true,{silent:true});
            this.render();
            $(this.gridEl).jqGrid('setSelection', selRowId-1);
        }
    }


    itemDown(){
        let myGrid = $(this.gridEl),
            selRowId = parseInt(myGrid.jqGrid ('getGridParam', 'selrow')),
            currentModel=this.model.get('currentListDetails'),
            currentModelItems=currentModel.CustomListXML.CustomList.Item;

        if ( selRowId < ( currentModelItems.length-1)){
            currentModelItems=[...currentModelItems.slice(0,selRowId),currentModelItems[selRowId+1],currentModelItems[selRowId],...currentModelItems.slice(selRowId + 2)];
            currentModel.CustomListXML.CustomList.Item=currentModelItems;

            this.model.set('currentListDetails', currentModel,{silent:true});
            this.model.set('hasChanges',true,{silent:true});
            this.render();
            $(this.gridEl).jqGrid('setSelection', selRowId+1);
        }
    }

    itemNew(){
        let currentModel=this.model.get('currentListDetails'),
            currentModelItems=currentModel.CustomListXML.CustomList ? currentModel.CustomListXML.CustomList.Item:[];
        var newRow = {
            '@caption':'Caption' ,
            '@value': 'Value'
        };
        var newGridRow = {
            'caption':'Caption' ,
            'value': 'Value'
        };
        $(this.gridEl).addRowData((currentModelItems.length + 1), newGridRow);

        currentModelItems.push(newRow);

        if(!currentModel.CustomListXML.CustomList.Item){
            currentModel.CustomListXML.CustomList={
                "Item":currentModelItems
            }
        }

        this.model.set('currentListDetails', currentModel,{silent:true});
        this.model.set('hasChanges',true,{silent:true});
        this.render();
    }

    fillNewRow(index, caption, value) {
        $(this.gridEl).addRowData(index, {'caption':caption, 'value':value});
        $(this.gridEl).jqGrid('setSelection', index);
    }

    itemRemove(){
        let myGrid = $(this.gridEl),
            selRowId = parseInt(myGrid.jqGrid ('getGridParam', 'selrow')),
            currentModel=this.model.get('currentListDetails'),
            currentModelItems=currentModel.CustomListXML.CustomList.Item;

        currentModelItems=[...currentModelItems.slice(0,selRowId),...currentModelItems.slice(selRowId + 1)];
        currentModel.CustomListXML.CustomList.Item=currentModelItems;
        this.model.set('currentListDetails', currentModel,{silent:true});
        this.model.set('hasChanges',true,{silent:true});
        this.render();
        console.log("Model After Save Cell",currentModel);
    }

     quickPaste(ev){
         let quickPasteModal=new QuickPasteModal({model:new Model({pastedText:"",captions:[],values:[]})}),
             currentModel=this.model.get('currentListDetails'),
             currentModelItems=currentModel.CustomListXML.CustomList.Item;
         quickPasteModal.render().then((result)=>{
            if (result !== 'Cancel') {
                 if(result.captions.length > 0 && result.values.length > 0){
                     for(let i=0;i<result.captions.length;i++){
                         let newRow = {
                             '@caption':result.captions[i] || result.values[i] || '',
                             '@value': result.values[i] || result.captions[i] || ''
                         };
                         let newGridRow = {
                             'caption':result.captions[i] || result.values[i] || '',
                             'value': result.values[i] || result.captions[i] || ''
                         };
                         $(this.gridEl).addRowData((currentModelItems.length + 1), newGridRow);
                         currentModelItems.push(newRow);
                     }
                 }
                 currentModel.CustomListXML.CustomList.Item=currentModelItems;
                 this.model.set('currentListDetails',currentModel,{silent:true});
                 this.model.set('hasChanges',true,{silent:true});
                 this.render();
                 console.log("Model After Save Cell",currentModel);
            }
         });
     }

     importList(){
         let commonImportModalView = new CommonImportModal({model:new Model({name:''})});
         commonImportModalView.render().then((result)=>{
             if(result && result !== 'Cancel'){
                 RestService.importFile(result.name, result.file, this.model.get('listId'), result.type).then((importResult)=> {
                     console.log('Import Result', importResult);
                     eventBus.trigger(constants.EV_UPDATE_CUSTOM_LIST_DETAILS, this.model.get('listId'));
                 }).catch((err=> {
                     console.log('Error While Importing File', err);
                     NotificationService.error('Error While Importing File' + err.MESSAGE);
                 }));
             }
         })
     }

    setRow(rowId, e){
        $(`#${e.currentTarget.id}`).jqGrid('setSelection', rowId);
    }

    afterSaveCell(rowId, cellName, value, iRow, iCol){
        let currentModel=this.model.get('currentListDetails');
        currentModel.CustomListXML.CustomList.Item[rowId]['@'+cellName] = value;
        this.model.set('currentListDetails',currentModel,{silent:true});
        this.model.set('hasChanges',true,{silent:true});
        this.render();
    }

    onSelectRow(){}

    onCellSelect(){}

    onDoubleClickRow(rowId, iRow, iCol, e) {
    }

    afterEditCell(rowId, cellName, value, iRow, iCol) {
        let self=this;
        console.log("After activated","#" + iRow + "_" + cellName);
        $("#" + iRow + "_" + cellName).bind('blur', function () {
            console.log("Blur activated");
            $(self.gridEl).saveCell(iRow, iCol);
        });
    }

    render() {
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }


        this.renderGrid();

        this.delegateEvents();
        this.$el.css( 'cursor', 'default' );

        $('input[name="Name"]').focus().val("").val(this.model.get('currentListDetails').Name);

        return this;
    }

    refresh(){
        if(this.model.get('hasChanges')){            
            let simpleModal=new SimpleConfirmModal({
                model:new Model({subtitle:`List Details - ${this.model.get("listDetails").Name}`,
                    confirmationText:`Are you sure you want to refresh this page?\r All changes made on the current page will be lost.`,
                    height:200,
                    width:400})
            });
            simpleModal.render().then((result)=>{
                if (result === 'Ok') {
                    eventBus.trigger(constants.EV_REFRESH_LIST_DETAILS,this.model.get('listId'))
                }
            }).catch((err)=> {
                console.log('Error Showing Refresh Confirmation Message', err);
                NotificationService.error('Error Showing Refresh Confirmation Message' + err.MESSAGE);
            });
        }
        else{
            eventBus.trigger(constants.EV_REFRESH_LIST_DETAILS,this.model.get('listId'))
        }  
    }

    goToSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger('loadSettingsView');
    }

    goToAccountSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        $('div.document-heading > a[data-target="#well_1"]').click();
    }
}

export default ListDetailsView;
